// Translations
import tosDialog from '../components/tos-dialog/translations/de'

// Translation: Register > Landing > Form (German)
export default Object.freeze({
	components: { tosDialog },
	form: {
		actions: {
			continue: '',
			register: ''
		},
		fields: {
			email: {
				placeholder: ''
			},
			firstName: {
				placeholder: ''
			},
			lastName: {
				placeholder: ''
			},
			password: {
				placeholder: ''
			},
			passwordConfirmation: {
				placeholder: ''
			}
		},
		options: {
			login: {
				action: '',
				label: ''
			}
		},
		title: {
			accountInformation: '',
			profileDetails: ''
		}
	}
})
